// removed by extract-text-webpack-plugin
module.exports = {"op":"hzp9Ma_3J4T087Mz0mNv7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/BeautifulServices/BeautifulServices.scss
 ** module id = 1052
 ** module chunks = 0
 **/